import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManagerHeaderComponent } from './manager-header.component';
import { IonicModule } from '@ionic/angular';
import { PosManagerMenuModule } from 'src/app/components/pos-manager/menu/pos-manager.module';
import { TranslocoModule } from '@ngneat/transloco';
import { LanguageSwitcherModule } from '../../language-switcher/language-switcher.module';
import { TrainingModeBannerComponentModule } from 'src/app/components/shared/training-mode-banner/training-mode-banner-component.module';

@NgModule({
  declarations: [ManagerHeaderComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslocoModule,
    LanguageSwitcherModule,
    PosManagerMenuModule,
    TrainingModeBannerComponentModule
  ],
  exports: [ManagerHeaderComponent]
})
export class ManagerHeaderComponentModule {}
